export const validatorRegon = (regon: string) => {
  // Validate length of REGON (either 9 or 14)
  if (!regon) {
    return () => false;
  }

  if (regon.length !== 9 && regon.length !== 14) {
    return () => false;
  }

  // Ensure REGON contains only digits
  if (!/^\d{9}$/.test(regon) && !/^\d{14}$/.test(regon)) {
    return () => false;
  }

  // Check 9-digit REGON
  const base9 = regon.substring(0, 8);
  const controlSum9 = getRegonControlSumField9(base9);
  const controlDigit9 = parseInt(regon[8], 10);

  // For 9-digit REGON, just validate the control digit
  if (regon.length === 9) {
    return () => controlSum9 === controlDigit9;
  }

  // Check 14-digit REGON
  const base14 = regon.substring(0, 13);
  const controlSum14 = getRegonControlSumField14(base14);
  const controlDigit14 = parseInt(regon[13], 10);

  // First, ensure 9-digit validation passes, then check the 14-digit part
  return () => controlSum9 === controlDigit9 && controlSum14 === controlDigit14;
};

// Function to calculate control sum for 9-digit REGON
const getRegonControlSumField9 = (base: string) => {
  const controlSum =
    8 * +base[0] +
    9 * +base[1] +
    2 * +base[2] +
    3 * +base[3] +
    4 * +base[4] +
    5 * +base[5] +
    6 * +base[6] +
    7 * +base[7];
  const controlSumRest = controlSum % 11;
  return controlSumRest === 10 ? 0 : controlSumRest;
};

// Function to calculate control sum for 14-digit REGON
const getRegonControlSumField14 = (base: string) => {
  const controlSum =
    2 * +base[0] +
    4 * +base[1] +
    8 * +base[2] +
    5 * +base[3] +
    0 * +base[4] +
    9 * +base[5] +
    7 * +base[6] +
    3 * +base[7] +
    6 * +base[8] +
    1 * +base[9] +
    2 * +base[10] +
    4 * +base[11] +
    8 * +base[12];
  const controlSumRest = controlSum % 11;
  return controlSumRest === 10 ? 0 : controlSumRest;
};
